<template>
  <div>
    <md-table
      v-if="concepts.length"
      id="validation-concepts-table"
      md-card
      class="table-hover"
    >
      <md-table-row>
        <md-table-head></md-table-head>
        <md-table-head><strong>Cantidad</strong></md-table-head>
        <md-table-head><strong>Concepto</strong> </md-table-head>
        <md-table-head><strong>Precio unitario</strong> </md-table-head>
        <md-table-head><strong>Subtotal</strong> </md-table-head>
        <md-table-head></md-table-head>
      </md-table-row>

      <template v-for="(concept, index) in concepts">
        <md-table-row
          :key="index"
          :class="{
            'empty-concept': !concept.supplies.length || concept.toDelete,
          }"
        >
          <md-table-cell>
            <div class="button-container" style="width: 40px">
              <template>
                <md-button
                  v-if="concept.supplies.length"
                  class="md-round md-just-icon md-info"
                  @click="concept.showSupplies = !concept.showSupplies"
                >
                  <md-icon>{{
                    !concept.showSupplies ? "expand_more" : "expand_less"
                  }}</md-icon>
                </md-button>
                <div v-else>
                  <md-icon>warning</md-icon>
                </div>
              </template>
            </div>
          </md-table-cell>
          <md-table-cell md-label="Cantidad" style="width: 120px">
            <div class="outlined-field-dense">
              <md-field>
                <md-input
                  v-model="concept.quantity"
                  type="number"
                  step="0.000001"
                  :disabled="disableAll || concept.toDelete"
                >
                </md-input>
                <span class="md-suffix">
                  {{ concept.unitMeasurement.abbr }}
                </span>
              </md-field>
            </div>
          </md-table-cell>
          <md-table-cell md-label="Concepto">
            <p class="concept_info_table">
              <span class="md-body-2">
                {{ concept.name }}
              </span>
            </p>
            <p
              class="md-body-1 concept_info_table"
              v-if="
                !!concept.description && concept.description !== concept.name
              "
            >
              <strong> Descripción: </strong>
              {{ concept.description }}
            </p>
          </md-table-cell>
          <md-table-cell md-label="Precio" style="width: 120px">
            <p class="md-body-1 concept_info_table">
              $
              {{ concept.unitPriceMXN || concept.unitPriceUSD }}
            </p>
          </md-table-cell>

          <md-table-cell md-label="Subtotal" style="width: 120px">
            <p class="md-body-1 concept_info_table">
              $ {{ getSubtotalConcept(concept) }}
            </p>
          </md-table-cell>

          <md-table-cell md-label="Acciones" style="width: 120px">
            <md-button
              v-if="!disableAll && concept.id === 0"
              class="md-info md-simple md-just-icon"
              style="width: 120px"
              @click="removeConcept(concept)"
            >
              <md-icon>close</md-icon>
            </md-button>
            <md-button
              v-else-if="!disableAll && concept.id !== 0"
              class="md-danger md-simple md-just-icon"
              @click="removeConcept(concept)"
            >
              <md-icon>delete</md-icon>
            </md-button>
          </md-table-cell>

          <md-tooltip
            v-if="concept.internal_concept || !concept.supplies.length"
          >
            {{ concept.internal_concept ? internalCon : emptyCon }}
          </md-tooltip>
        </md-table-row>

        <md-table-row class="supplies__row" v-show="concept.showSupplies">
          <md-table-cell colspan="6" v-if="concept.supplies.length">
            <md-table class="md-elevation-2">
              <md-table-toolbar style="min-height: 36px">
                <h1 class="md-subheading">
                  <strong> {{ concept.supplies.length }} Insumos </strong>
                </h1>
              </md-table-toolbar>
              <md-table-row>
                <md-table-head> </md-table-head>
                <md-table-head> Cantidad </md-table-head>
                <md-table-head> Código </md-table-head>
                <md-table-head> Insumo </md-table-head>
                <md-table-head></md-table-head>
              </md-table-row>

              <md-table-row
                v-for="(supply, index) in concept.supplies"
                :key="supply.id"
                :class="{
                  'not-to-do-concept': !supply.expired_price,
                  'text-gray': supply.dontUse,
                  'last-supply-row': index + 1 === concept.supplies.length,
                }"
              >
                <md-table-cell> </md-table-cell>
                <md-table-cell>
                  {{ supply.quantity }}
                </md-table-cell>
                <md-table-cell>
                  {{ supply.supplyData.code }}
                </md-table-cell>
                <md-table-cell>
                  {{ supply.supplyName }}
                </md-table-cell>
                <md-table-cell>
                  <div v-if="supply.expired_price">
                    <md-icon
                      :class="{
                        'text-warning': supply.expired_price,
                      }"
                    >
                      event_busy
                    </md-icon>
                    <md-tooltip>Precio expirado</md-tooltip>
                  </div>
                  <div v-else>
                    <md-icon> event_available </md-icon>
                    <md-tooltip>Precio actual</md-tooltip>
                  </div>
                  <md-tooltip>Precio expirado</md-tooltip>
                </md-table-cell>

                <md-table-cell v-if="showSupplyUsageHeader">
                  <md-checkbox
                    v-model="supply.dontUse"
                    :disabled="supplyUsageDisabled"
                  />
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-table-cell>
          <md-table-cell colspan="4" v-else>
            <loading-content
              class="md-accent"
              empty-icon="widgets"
              empty-label="No hay insumos"
              empty-description="El concepto no tiene insumos"
            />
          </md-table-cell>
        </md-table-row>
      </template>

      <md-table-row v-if="concepts.length" class="table__total-row">
        <md-table-cell></md-table-cell>
        <md-table-cell>TOTAL</md-table-cell>
        <md-table-cell></md-table-cell>
        <md-table-cell></md-table-cell>
        <md-table-cell>{{
          totalQuantificationCalculated | money
        }}</md-table-cell>
        <md-table-cell></md-table-cell>
      </md-table-row>
    </md-table>
    <loading-content
      v-else
      empty-icon="category"
      empty-label="No hay conceptos por validar"
      :empty-description="emptyDescription"
    />
  </div>
</template>

<script>
const EMPTY_QUANTIFICATION_MSG = "No puede agregar nuevos conceptos.";
const ADD_CONCEPTS_MSG = "Agregue conceptos con el selector inferior.";
const INTERNAL_MSG =
  "Este concepto es interno, por lo tanto no aparecera en el Acta Entrega";
const EMPTY_CONCEPT_MSG =
  "El concepto no contiene insumos, porfavor agregue almenos uno";

import percentage from "@/filters/percentage";
import usesAccountInfoMixin from "@/mixins/usesAccountInfo";

export default {
  name: "ConceptsTable",

  mixins: [usesAccountInfoMixin],

  props: {
    quantification: {
      required: true,
    },
    concepts: {
      type: Array,
      required: true,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    disableAll: {
      type: Boolean,
      default: false,
    },
    selectionBlacklist: {
      type: Array,
      default: () => [],
    },
    conceptSelectionMode: {
      type: Boolean,
      default: true,
    },
    conceptsIssues: {
      type: Object,
      default: () => ({}),
    },
    showSupplyUsageHeader: Boolean,
    supplyUsageDisabled: Boolean,
  },

  filters: {
    percentage,
  },

  data() {
    return {
      selectedConcepts: {},
      emptyCon: EMPTY_CONCEPT_MSG,
      internalCon: INTERNAL_MSG,
      currentSupplyCopy: null,
      nonUsedSupplies: [],
    };
  },

  computed: {
    suppliesTotal() {
      if (!this.concepts.length) {
        return 0;
      }
      const total = this.concepts.reduce(
        (sum, concept) => sum + concept.quantity * +concept.suppliesSum,
        0
      );
      return +total.toFixed(2);
    },

    directCost() {
      const { totalQuantificationCalculated: total, suppliesTotal } = this;
      return !!total ? (suppliesTotal * 100) / total : total;
    },

    emptyDescription() {
      return this.disableAll ? EMPTY_QUANTIFICATION_MSG : ADD_CONCEPTS_MSG;
    },
    totalQuantificationCalculated() {
      const total = this.concepts.reduce((sum, concept) => {
        const price = concept.unitPriceMXN * concept.quantity;
        return +sum + +price.toFixed(2);
      }, 0);
      return +total.toFixed(2);
    },
  },

  watch: {
    selectable(value) {
      if (!value) {
        for (const concept of this.concepts) {
          concept.selected = false;
          concept.showSupplies = false;

          for (const supply of concept.supplies) {
            supply.selected = false;
          }
        }
      } else {
        for (const concept of this.concepts) {
          concept.showSupplies = true;
        }
      }
    },
  },

  methods: {
    removeConcept(concept) {
      this.$emit("removeConcept", concept);
    },
    getSubtotalConcept({ unitPriceMXN, unitPriceUSD, quantity }) {
      const total = unitPriceMXN
        ? unitPriceMXN * +quantity
        : unitPriceUSD * +quantity;
      return +total.toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine";
.concept_info_table {
  margin: 0;
}
.supplies__row {
  background-color: #f9f9f9 !important;
}

.empty-concept {
  background: md-get-palette-color(red, 100);
}

.not-to-do-concept {
  background: md-get-palette-color(lime, 100) !important;
}
.outlined-field-dense {
  width: 140px;
  margin: 0;
  font-weight: 400;
}

.table__total-row {
  background-color: #f3f3f3;
  font-weight: 500;
}

@include md-register-theme(
  "success-card",
  (
    accent: md-get-palette-color(green, 500),
  )
);
</style>



// WEBPACK FOOTER //
// src/pages/RoadSinisters/File/ConceptsValidation/ValidationConceptsTable.vue